/**
 * 领域热点
 * 2017-11-19
 * Bai.Zhiming
 */
"use strict";
angular.module("fieldHotSpotsModule", ["PlanHotPointDetailModule", "hotSearchListModule", "hotPointDetailLineModule", "hotPointDetailPieModule", "hotEchartsMapModule", "treeRedialChartModule"]).
controller("fieldHotSpotsCtrl", ["$scope", "$q", "$filter", "trsHttpService", "modalDialog", "initHotHead", "randomTxtListNew", "storageListenerService", function($scope, $q, $filter, trsHttpService, modalDialog, initHotHead, randomTxtListNew, storageListenerService) {
    initStatus();
    initData();

    function initStatus() {
        $scope.toggleChart = 'table'; //切换全网热点表格
        $scope.peopleToggleChart = 'table'; //切换网民关注表格
        $scope.hotCList = 0; //切换全网热点选项栏使用
        $scope.rankReport = 0;
        $scope.status = {
            fzItems: [],
            newspaperChooseTime: initHotHead.initpaperTime(),
        };
        $scope.data = {
            hotLists: {
                page: {
                    "pn": 0,
                    "PAGESIZE": 20,
                    "ITEMCOUNT": 0,
                    "startpage": 0
                },
                status: {
                    "jumpToPageNum": 1,
                    "startpage": 0
                }
            },
        };
        $scope.rankFtime = 0; //用于 首发时间
        // hotRefersh();
        ////获取日期轴数据
        getDateLineData();
        //获取小时时间轴
        hourData();
    }

    function initData() {
        $scope.status.time = $scope.status.newspaperChooseTime[2];
        //初始化网媒
        // getWebsiteMediaData();
        //纸媒头版
        // hotkeyrank();
        // setnav(1);
        // console.log("in");
        hotAggregateTab();

    }
    /**
     * [handleDate description] 处理日期
     * @param  {[type]} item [description] 稿件
     * @return {[type]}      [description]
     */
    $scope.handleDate = function(item) {
        item.FIRSTTIME = $filter("date")(new Date(Date.parse(item.FIRSTTIME)), "yyyy-MM-dd HH:mm:ss");
    };
    //热点频道订阅  重构后
    $scope.showDiscloseConfig = function() {
        $scope.dingyue = {};
        $scope.dingyue.selectedArray = [];
        $scope.dingyue.delectedArray = [];
        $scope.dingyue.params = {
            "typeid": "widget",
            "serviceid": "hotpointevent",
            "modelid": "userfields",
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.dingyue.params, "get").then(function(data) {
            $scope.dingyue.items = data;
            console.log(data);
            angular.forEach(data, function(array, key) {
                if (array.ORDERNUM == 1) {
                    $scope.dingyue.selectedArray.push(array);
                    $scope.dingyue.ID = trsspliceString.spliceString($scope.dingyue.selectedArray, "ID", ",");
                } else {
                    $scope.dingyue.delectedArray.push(array);
                }
            });
        });


        $scope.dingyue.selectItem = function(item, isSelect) {
            if (isSelect) {
                $scope.dingyue.selectedArray.splice($scope.dingyue.selectedArray.indexOf(item), 1);
                $scope.dingyue.delectedArray.push(item);
            } else {
                $scope.dingyue.selectedArray.push(item);
                $scope.dingyue.delectedArray.splice($scope.dingyue.delectedArray.indexOf(item), 1);
            }
            $scope.dingyue.ID = trsspliceString.spliceString($scope.dingyue.selectedArray, "ID", ",");
        };

        $scope.dingyue.cancel = function() {
            $scope.dingyue.show = false;
        };

        $scope.dingyue.save = function() {
            $scope.dingyue.params.modelid = "saveuserfields";
            $scope.dingyue.params.fields = $scope.dingyue.ID;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.dingyue.params, "post").then(function(data) {
                $scope.status.fzItems = [];
                hotAggregateTab();
                $scope.dingyue.show = false;
            });
        };
        $scope.dingyue.show = true;
        /*var modalInstance = $modal.open({
            templateUrl: "./planningCenter/cueSelectedTopic/hotHeadLine/service/hotHeadPolymerization/hotHeadPolymerization.html",
            windowClass: "cue-monitor-disclose-config-window",
            controller: "hotHeadPolymerizationCtrl",
            resolve: {
                title: function() {
                    return "热点聚合图";
                }
            }
        });
        modalInstance.result.then(function() {
            $scope.status.fzItems = [];
            hotAggregateTab();
        });*/
    };
    //初始化 热点聚合TAB
    function hotAggregateTab() {
        var defer = $q.defer();
        // var firstmodal = {
        //     DICTNAME: "全网",
        //     DICTNUM: "000",
        //     ID: "zyzxfield_000",
        //     ORDERNUM: "1",
        // };
        // $scope.status.fzItems.push(firstmodal);
        var params = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "userfields",
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            $scope.hotListFirst=data[0].ID;
            hotPicDetail({
                ID: $scope.hotListFirst
            });
            angular.forEach(data, function(value, key) {
                // if (value.ORDERNUM == 1 && !contains($scope.status.fzItems, value)) {
                $scope.status.fzItems.push(value);
                // }
            });
            defer.resolve(data);
        });
        return defer.promise;
    }
    //数组是否包含元素   仅限本处菜单是否重复的比较
    function contains(array, needle) {
        for (var i in array) {
            if (array[i].ID == needle.ID) return true;
        }
        return false;
    }
    /**
     * [ getDateLine description] 获取时间轴数据
     */
    function getDateLineData() {
        var date = new Date();
        $scope.status.nowDayIndex = 0;
        $scope.data.dateLine = [];
        for (var i = 6; i >= 0; i--) {
            var tempDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - i);
            var month = parseInt((tempDate.getMonth() + 1)) < 10 ? ("0" + (tempDate.getMonth() + 1)) : (tempDate.getMonth() + 1);
            var day = parseInt(tempDate.getDate()) < 10 ? ("0" + tempDate.getDate()) : tempDate.getDate();
            $scope.data.dateLine.push(tempDate.getFullYear() + "-" + month + "-" + day);
        }
        $scope.status.selectedDate = $scope.data.dateLine[6];
        $scope.status.curDate = $scope.data.dateLine[6];

    }
    $scope.next_day = function() {
        $scope.data.dateLine = [];
        $scope.status.nowDayIndex++;
        var date = new Date();
        if ($scope.status.nowDayIndex > 0)
            $scope.status.nowDayIndex = 0;
        for (var i = $scope.status.nowDayIndex * 7 - 6; i <= $scope.status.nowDayIndex * 7; i++) {
            var tempDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + i);
            var month = parseInt((tempDate.getMonth() + 1)) < 10 ? ("0" + (tempDate.getMonth() + 1)) : (tempDate.getMonth() + 1);
            var day = parseInt(tempDate.getDate()) < 10 ? ("0" + tempDate.getDate()) : tempDate.getDate();
            $scope.data.dateLine.push(tempDate.getFullYear() + "-" + month + "-" + day);
        }
    };
    $scope.prev_day = function() {
        $scope.data.dateLine = [];
        $scope.status.nowDayIndex--;
        var date = new Date();
        for (var i = $scope.status.nowDayIndex * 7 - 6; i <= $scope.status.nowDayIndex * 7; i++) {
            var tempDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + i);
            var month = parseInt((tempDate.getMonth() + 1)) < 10 ? ("0" + (tempDate.getMonth() + 1)) : (tempDate.getMonth() + 1);
            var day = parseInt(tempDate.getDate()) < 10 ? ("0" + tempDate.getDate()) : tempDate.getDate();
            $scope.data.dateLine.push(tempDate.getFullYear() + "-" + month + "-" + day);
        }

    };
    /**
     * [ chooseDate description] 选择日期
     *  @param {[date]} [varname] [description]所选日期
     */
    $scope.chooseDate = function(date) {
        // if (!!$scope.hotPicPromise) return;
        //console.log(date);

        $scope.status.selectedDate = date;
        hotPicDetail($scope.status.selectedItem).then(function() {});

        if ($scope.status.curDate != date) {
            $scope.chooseHour(23);
            lastDayHourData();
        } else {
            var date = new Date();

            var curHour = date.getHours();
            // console.log('in'+curHour)
            $scope.chooseHour(curHour);
            hourData();
        }


    };

    function hotPicDetail(item) {
        var deffer = $q.defer();
        var params = {
            "typeid": "widget",
            "serviceid": "hotpointevent",
            "modelid": "hotpointnews",
            "loaddate": $scope.status.selectedDate + " " + (parseInt($scope.status.selectedHour) < 10 ? '0' + $scope.status.selectedHour : $scope.status.selectedHour),
            //"loadtime":"2017-01-16 17",
            "field": item.ID,
            "page_no": 0,
            "page_size": 20
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) { //feefe
                $scope.peoHotField = item.ID;
                $scope.hotALists = [];
                angular.copy(data.PAGEITEMS, $scope.hotALists); //获取全部列表数据，避免重复加载
                $scope.nowListTime = formateDate(new Date());
                $scope.data.hotLists.page.pn = data.STARTPAGE + 1;
                $scope.data.hotLists.page.PAGESIZE = data.PAGESIZE;
                $scope.data.hotLists.page.ITEMCOUNT = data.TOTALITEMCOUNT;
                $scope.data.hotLists.page.PAGECOUNT = data.TOTALPAGECOUNT;
                storageListenerService.previewPageTurningStorage(data.PAGEITEMS, "GUID", "resourceDetail"); //lingyu
                deffer.resolve($scope.hotNums);
        });
        return deffer.promise;
    }
    //点击日期时获取昨天的时间轴
    function lastDayHourData() {
        var start = 0,
            end = 0;
        var curHour = $scope.status.curHour = 23 + "";
        $scope.data.hours = [];
        if (curHour >= 0 && curHour <= 7) {
            start = 0;
            end = 7;
            $scope.status.nowHourIndex = 1;
        } else if (curHour >= 8 && curHour <= 15) {
            start = 8;
            end = 15;
            $scope.status.nowHourIndex = 2;
        } else if (curHour >= 16 && curHour <= 23) {
            start = 16;
            end = 23;
            $scope.status.nowHourIndex = 3;
        }
        for (var i = start; i <= end; i++) {
            $scope.data.hours.push(i + "");
            if ((i + "") === $scope.status.curHour + "") {
                $scope.status.selectedHour = i + "";
            }
        }
    }
    /**
     * [ hourData description] 获取小时时间轴数据
     */
    function hourData() {
        var date = new Date();
        var start = 0,
            end = 0;
        var curHour = $scope.status.curHour = date.getHours() + "";
        $scope.data.hours = [];
        if (curHour >= 0 && curHour <= 7) {
            start = 0;
            end = 7;
            $scope.status.nowHourIndex = 1;
        } else if (curHour >= 8 && curHour <= 15) {
            start = 8;
            end = 15;
            $scope.status.nowHourIndex = 2;
        } else if (curHour >= 16 && curHour <= 23) {
            start = 16;
            end = 23;
            $scope.status.nowHourIndex = 3;
        }
        for (var i = start; i <= end; i++) {
            $scope.data.hours.push(i + "");
            if ((i + "") === $scope.status.curHour + "") {
                $scope.status.selectedHour = i + "";
            }
        }

    }
    /**
     * [ chooseHour description] 选择小时
     *  @param {[date]} [varname] [description]所选小时
     */
    $scope.chooseHour = function(hour) {
        // if (!!$scope.hotPicPromise) return;
        if ($scope.compareHour(hour)) return;
        $scope.status.selectedHour = hour;
        hotPicDetail($scope.status.selectedItem).then(function() {});
    };
    /**
     * [ prev_hour description] 小时向前切换  
     *  
     */
    $scope.prev_hour = function() {

        if ($scope.status.nowHourIndex > 1)
            $scope.status.nowHourIndex--;
        else {
            $scope.status.nowHourIndex = 1;
        }
        $scope.data.hours = new Array();
        for (var i = $scope.status.nowHourIndex * 8 - 8; i <= $scope.status.nowHourIndex * 8 - 1; i++) {
            $scope.data.hours.push(i + "");
        }
    };
    /**
     * [ prev_hour description] 小时向后切换  
     *  
     */
    $scope.next_hour = function() {
        if ($scope.status.nowHourIndex < 3)
            $scope.status.nowHourIndex++;
        else {
            $scope.status.nowHourIndex = 3;
        }
        $scope.data.hours = new Array();
        for (var i = $scope.status.nowHourIndex * 8 - 8; i <= $scope.status.nowHourIndex * 8 - 1; i++) {
            $scope.data.hours.push(i + "");
        }
    };
    /**
     * [ compareHour description] 比较小时
     *  @param {[date]} [varname] [description]所选小时
     */
    $scope.compareHour = function(hour) {
        var selectedHour = parseInt(hour);
        var curHour = $scope.status.curHour;
        var selectedTime = new Date(Date.parse($scope.status.selectedDate.replace(/-/g, "/") + " " + selectedHour + ":0:0"));
        var curTime = new Date();
        //return parseInt($scope.status.curHour) < trueHour;
        return curTime < selectedTime;
    };
    /**
     * [NUMSTRVALUE description]  热点头条、网名热搜 不同分辨率下 截取不同长度
     * @param {[type]} STRVALUE [description]
     */
    $scope.NUMSTRVALUE = function(STRVALUE) {
        if (window.screen.width <= '1366') {
            STRVALUE = $filter('trsLimitTo')(STRVALUE, '15');
        } else if (window.screen.width <= '1680' && window.screen.width > '1366') {
            STRVALUE = $filter('trsLimitTo')(STRVALUE, '18');
        } else if (window.screen.width > '1680') {
            STRVALUE = $filter('trsLimitTo')(STRVALUE, '20');
        }
        return STRVALUE;
    };
    //点击热点聚合TAB
    $scope.hotPic = function(item) {
        $scope.status.selectedItem = item;
        $scope.hotNums = [];
        hotPicDetail(item);
    };
    $scope.getImageStyle = function(url, type) {
        var styleObj = {};
        if (url !== null) { //&&CheckImgExists(url)
            if (type == 'li') {
                if (url.length > 0) {
                    url = url.split(";")[0];
                }
                styleObj = {
                    "background": "url('" + url + "')",
                    "background-size": "cover"
                };
            } else if (type == 'a') {
                styleObj = {
                    "background": "url('./planningCenter/images/img_bg.png')",
                    "background-size": "cover"
                };
            }
        }
        return styleObj;
    };
    $scope.getImageUrl = function(url) {
        if (url !== null && url.length > 0) {
            return url.split(";")[0];
        }
    };
    $scope.hotLists = function(item, index, sortName) {
        if (sortName) {
            $scope.hotSortName = sortName;
            if (sortName == 'SY_CLUSTER_NUMS') {
                $scope.rankReport++;
                $scope.isRankReport = $scope.isRankReport == 1 ? 2 : 1;
                $scope.rankType = $scope.rankReport % 2 == 0 ? 'desc' : 'asc';
            } else if (sortName == 'SY_FIRSTTIME') {
                $scope.rankFtime++;
                $scope.isRankFtime = $scope.isRankFtime == 1 ? 2 : 1;
                $scope.rankType = $scope.rankFtime % 2 == 0 ? 'desc' : 'asc';
            }
        }
        if (item != null && item != 999) {
            $scope.peoHotField = item.ID;
            $scope.data.hotLists.page.startpage = 0;
        }

        var deffer = $q.defer();
        if (index !== null && index != 999 && index !== undefined) $scope.hotCList = index;
        var params = {
            "typeid": "widget",
            "serviceid": "hotpointevent",
            "modelid": "hotpointnews",
            "loaddate": $scope.status.selectedDate + " " + (parseInt($scope.status.selectedHour) < 10 ? '0' + $scope.status.selectedHour : $scope.status.selectedHour),
            "field": $scope.peoHotField,
            "page_no": $scope.data.hotLists.page.startpage,
            "page_size": 20,
            "orderfield": $scope.hotSortName ? $scope.hotSortName : '',
            "ordermode": $scope.hotSortName ? $scope.rankType : ''

        };
        //获取当前时间用于计算持续时间


        $scope.nowListTime = formateDate(new Date());
        // console.log($scope.nowListTime);

        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            $scope.data.hotLists.page.pn = data.STARTPAGE + 1;
            $scope.data.hotLists.page.PAGESIZE = data.PAGESIZE;
            $scope.data.hotLists.page.ITEMCOUNT = data.TOTALITEMCOUNT;
            $scope.data.hotLists.page.PAGECOUNT = data.TOTALPAGECOUNT;
            // delete $scope.hotPicPromise;
            $scope.hotALists = data.PAGEITEMS;
            $scope.hotAListsFirstOne=data.PAGEITEMS[0];
            // data.PAGEITEMS.sort(function(a,b){
            //     return b.WEIGHTVALUE-a.WEIGHTVALUE;   
            // });                   

            // console.log($scope.hotNums)
            deffer.resolve($scope.hotALists);
        });
        return deffer.promise;
    };
    //格式化日期
    function formateDate(date) {
        var year = date.getFullYear();
        var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return year + '/' + month + '/' + day + ' ' + hour + ":" + minutes + ":" + seconds;
    }
    //计算持续时间
    $scope.durationTime = function(firstTime, loadtime) {
        var d1 = new Date(firstTime);
        var d2 = new Date(loadtime);
        var gap = Math.ceil(Math.abs(d1 - d2) / 1000 / 60 / 60);
        // console.log(d1);
        // console.log(d2);
        // console.log(gap);
        return gap + "小时";
    };
    //获取引爆媒体
    $scope.getHotMedia = function(me) {
        // console.log(me);
        if (me === null) return '&nbsp;';
        var media = me.split(';')[0].split(':')[0].substring(0, 8);
        return media;
    };
    $scope.getHotMediaTitle = function(me) {
        // console.log(me);
        if (me === null) return '&nbsp;';
        var media = me.split(';')[0].split(':')[0];
        return media;
    };
    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.data.hotLists.status.jumpToPageNum = $scope.data.hotLists.page.pn;
        $scope.data.hotLists.page.startpage = $scope.data.hotLists.page.pn - 1;
        $scope.hotLists();
    };
    $scope.jumpToPage = function() {
        if ($scope.data.hotLists.status.jumpToPageNum > $scope.data.hotLists.page.PAGECOUNT) {
            $scope.data.hotLists.status.jumpToPageNum = $scope.data.hotLists.page.PAGECOUNT;
        }
        if ($scope.data.hotLists.status.jumpToPageNum === "0" || isNaN(Number($scope.data.hotLists.status.jumpToPageNum))) {
            modalDialog.alertType("请输入合法的页码", "", "warning", false);
            return;
        }
        $scope.data.hotLists.page.startpage = $scope.data.hotLists.status.jumpToPageNum - 1;
        $scope.hotLists();
    };
    //刷新热点聚合
    // $scope.hotRefersh = function() {
    //     hotRefersh();
    // };

    // function hotRefersh() {
    //     $scope.status.fzItems = [];
    //     var firstModal = {
    //         DICTNAME: "全网",
    //         DICTNUM: "000",
    //         ID: "zyzxfield_000",
    //         ORDERNUM: "1",
    //     };
    //     $scope.status.fzItems.push(firstModal);
    //     $scope.hotNums = [];
    //     var params = {
    //         typeid: "widget",
    //         serviceid: "hotpointevent",
    //         modelid: "userfields",
    //     };
    //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
    //         for (var i in data) {
    //             if (data[i].ORDERNUM == 1 && !contains($scope.status.fzItems, data[i])) {
    //                 $scope.status.fzItems.push(data[i]);
    //             }
    //         }
    //         data = data == '' ? [] : data;
    //         data.unshift(firstModal);
    //         $scope.status.selectedItem = data[0];
    //         hotPicDetail(data[0]);
    //     });
    // }
}]);